import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import css from './DeepLinkTabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Internal from './Internal';
import External from './External';

const DeepLinkTabs = props => {
  const tabsRef = useRef(null);
  return (
    <Tabs
      defaultFocus
      selectedIndex={props.selectedIndex}
      onSelect={nextIndex => {
        props.setSelectedIndex(nextIndex);
        // This is a workaround for a bug with react tabs 
        // (the tab isn't focused upon click)
        setTimeout(() => {
          tabsRef.current && tabsRef.current.querySelector(`ul > li:nth-child(${nextIndex + 1})`).focus();
        }, 0);
      }}
      domRef={ref => { tabsRef.current = ref; }}
      className={css['tabs-container']}
      disabledTabClassName={css['tab-disabled']}
      selectedTabClassName={css['tab-selected']}
      selectedTabPanelClassName={css['panel']}>
      <TabList className={css['list-container']}>
        <Tab disabled={props.isInternalLinkValid}>External</Tab>
        <Tab disabled={props.isExternalURLValid}>Internal</Tab>
      </TabList>
        <TabPanel>
          <External 
            externalURL={props.externalURL}
            setExternalURL={props.setExternalURL}
            onSubmit={props.onSubmit}
          />
        </TabPanel>
        <TabPanel>
          <Internal 
            externalLinksOnly={props.externalLinksOnly}
            setInternalLink={props.setInternalLink}
            messageTemplateType={props.messageTemplateType}
            hasSSOMethod={props.hasSSOMethod}
          />
        </TabPanel>
    </Tabs>
  );
}

DeepLinkTabs.propTypes = {
  selectedIndex: PropTypes.number.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
  externalURL: PropTypes.string.isRequired,
  setExternalURL: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  externalLinksOnly: PropTypes.bool.isRequired,
  setInternalLink: PropTypes.func.isRequired,
  messageTemplateType: PropTypes.string,
  isExternalURLValid: PropTypes.bool.isRequired,
  isInternalLinkValid: PropTypes.bool.isRequired,
  hasSSOMethod: PropTypes.bool.isRequired,
};

export default DeepLinkTabs;
